import gsap from 'gsap'

import ee from '../ee'
import { siteHead } from './site-head'

const SERVICE_CARDS = []

class ServiceCard {
  constructor(el_card, el_popUp, index) {
    this.el_card = el_card
    this.el_popUp = el_popUp
    this.index = +index

    this.el_closeButton = el_popUp.querySelector('.js-service-close')
    this.el_previousButton = el_popUp.querySelector('.js-service-previous')
    this.el_nextButton = el_popUp.querySelector('.js-service-next')

    this.animation = null
    this.isPopUpOpen = false
    this.handleKeyDown = this.handleKeyDown.bind(this)
  }

  get nextCard() {
    let nextCardIndex = this.index + 1
    let firstCard = SERVICE_CARDS[0]

    return nextCardIndex < SERVICE_CARDS.length
      ? SERVICE_CARDS[nextCardIndex]
      : firstCard
  }

  get previousCard() {
    let previousCardIndex = this.index - 1
    let finalCard = SERVICE_CARDS[SERVICE_CARDS.length - 1]

    return previousCardIndex > 0 ? SERVICE_CARDS[previousCardIndex] : finalCard
  }

  get title() {
    return this.el_card.getAttribute('data-title')
  }

  addClickListeners() {
    let addClickListener = (element, callback) => {
      element.addEventListener('click', callback)
    }
    addClickListener(this.el_card, this.togglePopUp.bind(this))
    addClickListener(this.el_closeButton, this.togglePopUp.bind(this))
    addClickListener(this.el_nextButton, this.handleNavClick.bind(this, 1))
    addClickListener(this.el_previousButton, this.handleNavClick.bind(this, -1))
  }

  closePopUp(immediate = false) {
    this.animation?.kill()
    this.isPopUpOpen = false
    document.removeEventListener('keydown', this.handleKeyDown)
    this.setScrollLock(false)
    siteHead.show()

    this.animation = gsap.to(this.el_popUp, {
      autoAlpha: 0,
      duration: immediate ? 0 : 0.3,
      ease: 'linear',
    })
  }

  handleKeyDown(e) {
    if (e.key === 'Escape') {
      e.preventDefault()
      this.closePopUp()
    } else if (e.key === 'ArrowLeft') {
      this.handleNavClick(-1)
    } else if (e.key === 'ArrowRight') {
      this.handleNavClick(1)
    }
  }

  handleNavClick(direction) {
    this.closePopUp(true)

    if (direction > 0) {
      this.nextCard.openPopUp(true)
    } else {
      this.previousCard.openPopUp(true)
    }
  }

  init() {
    this.addClickListeners()
    this.initPopUpVisibility()
    this.setNavLabels()
  }

  initPopUpVisibility() {
    this.el_popUp.classList.remove('hidden')
    gsap.set(this.el_popUp, { autoAlpha: 0 })
  }

  openPopUp(immediate = false) {
    this.animation?.kill()
    this.isPopUpOpen = true
    document.addEventListener('keydown', this.handleKeyDown)
    this.setScrollLock(true)
    siteHead.hide()

    this.animation = gsap.to(this.el_popUp, {
      autoAlpha: 1,
      duration: immediate ? 0 : 0.5,
    })
  }

  setNavLabels() {
    this.el_previousButton.querySelector('.service__button__label').innerText =
      this.previousCard.title
    this.el_nextButton.querySelector('.service__button__label').innerText =
      this.nextCard.title
  }

  setScrollLock(isLocked) {
    document.body.style.overflow = isLocked ? 'hidden' : ''
  }

  togglePopUp() {
    if (this.isPopUpOpen) {
      this.closePopUp()
    } else {
      this.openPopUp()
    }
  }
}

function init() {
  let serviceCards = Array.from(document.querySelectorAll('.js-service-card'))
  let servicePopUps = Array.from(
    document.querySelectorAll('.js-service-pop-up')
  )

  for (let index in serviceCards) {
    SERVICE_CARDS.push(
      new ServiceCard(serviceCards[index], servicePopUps[index], index)
    )
  }

  SERVICE_CARDS.forEach((card) => card.init())
}

ee.addListener('initComponents', init)
